export default function useWhitelabelCustomization() {
  // this value will always be set for client logins
  const whitelabelCustomization =
    window.whitelabelCustomization === "%WHITELABEL_CUSTOMIZATION%"
      ? undefined
      : window.whitelabelCustomization;

  return { whitelabelCustomization };
}
